import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

export const FloatingContainer = styled.div`
  position: sticky;
  bottom: ${(props) => (props.hasZoomControlFooter ? `41px` : `0px`)};
  left: 0px;
  z-index: 9999;
  padding: 0 0 12px 12px;
  width: 43px;
`

export const Blurb = styled.div`
  border-radius: 15px;
  position: absolute;
  top: 0;
  padding: 8px 12px;
  color: ${themeColor('primaryPurple')};
  text-wrap: no-wrap;
  overflow: hidden;
  height: 22px;
  font-size: 10px;
`

export const QuestionMark = styled.div`
  background-color: ${themeColor('whitePrimary')};
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 5;
  top: 2px;
  right: 0px;
`

export const Transition = styled.div`
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 15px;
  transition: width 300ms ease-in-out;
  position: relative;
  box-shadow: 0 1px 5px 0 ${themeColor('lightPurple')};
  background-color: ${themeColor('whitePrimary')};

  &:hover {
    width: 182px;
    transition: width 1000ms ease-in-out;

    ${QuestionMark} {
      background-color: rgba(255, 255, 255, 0);
      transition: background-color 1000ms linear;
      width: 34px;
    }
  }
`
